// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kpad","icon":"styles_icon__3rVx7"};